import axios from 'axios';
import { Store } from 'redux';
import { IStore } from '../redux/IStore';
import { actions as authActions } from '../services/auth/reducer';

export default class AuthInterceptor {
  public ignoredUrls = [];
  public req = null;
  public res = null;
  public interceptor = null;
  private store: Store<IStore>;

  constructor(store: Store<IStore>) {
    this.store = store;
  }

  public registerInterceptor() {
    this.interceptor = axios.interceptors.response.use(this.requestSuccess, this.requestFailure.bind(this));
  }

  public requestSuccess = (response) => {
    return response;
  }

  public requestFailure = (error) => {
    if (this.ignoredUrls.length === 0) {
      this.ignoredUrls.push('/auth/login');
      this.ignoredUrls.push('/auth/refresh');
      this.ignoredUrls.push('/auth/logout');
      this.ignoredUrls.push(this.apiUrl('oauth/access_token'));
      // A wrong password is answered with a 401 here, it doesn't mean the session has gone
      this.ignoredUrls.push(this.apiUrl('customer/update-details'));
    }

    // Only deal with auth failures (cancelled requests and network errors have no response)
    if (! error.response || error.response.status !== 401
      || this.ignoredUrls.indexOf(error.response.config.url) !== -1) {
      return Promise.reject(error);
    }

    const config = error.response.config;

    if (! config.headers || ! config.headers.Authorization) {
      return Promise.reject(error);
    }

    // The token is no longer valid (expired, revoked, or issued before an API upgrade), so stop sending it
    delete axios.defaults.headers.common.Authorization;

    // Public endpoints also work anonymously: carry on without the token rather than failing the quote
    if (! config.anonymousRetry && config.url.indexOf(this.apiUrl('public/')) === 0) {
      this.store.dispatch(authActions.logout(false));

      delete config.headers.Authorization;
      config.anonymousRetry = true;

      return axios.request(config);
    }

    this.store.dispatch(authActions.logout());

    return Promise.reject(error);
  }

  private apiUrl(path: string): string {
    return (axios.defaults.baseURL || '').replace(/\/+$/, '') + '/' + path;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/helpers/AuthInterceptor.ts